import { getRotateAnimation } from '../animations/rotate'

// Half a turn around the fragment's own centre; the editor offers no angle or pivot for text.
const TEXT_ROTATION = 180

export function getTextRotateAnimation (element, settings) {
    return {
        from: getRotateAnimation(element, { withFade: settings.withFade ?? false, rotation: TEXT_ROTATION }),
    }
}
